import React from 'react';
import { Bell } from 'lucide-react';
import { validatePictureLink } from '../../utils/pushCampaignValidation';

interface PushPreviewProps {
  title: string;
  body: string;
  pictureLink: string;
  label: string;
}

export const PushPreview: React.FC<PushPreviewProps> = props => {
  const safePictureLink = validatePictureLink(props.pictureLink) == null ? props.pictureLink.trim() : '';
  return (
    <div className="rounded-xl bg-gray-800 p-4">
      <div className="mb-2 text-xs font-medium uppercase tracking-wide text-gray-400">{props.label}</div>
      <div className="rounded-2xl bg-white/95 p-3 shadow-lg">
        <div className="flex items-center gap-2 text-[11px] text-gray-500">
          <span className="flex h-4 w-4 items-center justify-center rounded bg-alps-primary text-white">
            <Bell className="h-3 w-3" />
          </span>
          <span className="font-medium text-gray-700">Mountly</span>
          <span>now</span>
        </div>
        <div className="mt-1 break-words text-sm font-semibold text-gray-900">
          {props.title.trim() === '' ? 'Notification title' : props.title}
        </div>
        <div className="break-words text-sm text-gray-700">
          {props.body.trim() === '' ? 'Notification body text' : props.body}
        </div>
        {safePictureLink !== '' && (
          <img
            src={safePictureLink}
            alt=""
            className="mt-2 max-h-32 w-full rounded-lg object-cover"
          />
        )}
      </div>
    </div>
  );
};
